import { useState } from "react";
import { LogOut, RefreshCw, Inbox, Store } from "lucide-react";
import { StoreLinksDialog } from "./StoreLinksDialog";

const ghostBtn =
  "inline-flex h-10 items-center gap-2 rounded-full border border-forest/15 px-4 text-xs font-bold text-forest transition-colors hover:border-fresh hover:text-fresh";

export const AdminHeader = ({ onDigest, onRefresh, onLogout }) => {
  const [linksOpen, setLinksOpen] = useState(false);

  return (
    <header className="sticky top-0 z-10 border-b border-forest/10 bg-white">
      <div className="mx-auto flex max-w-[1200px] flex-wrap items-center justify-between gap-y-2 px-6 py-4">
        <p className="font-syne text-xl font-extrabold text-forest">
          Freshly<span className="text-fresh">.</span>{" "}
          <span className="text-sm font-bold text-forest/40">Admin</span>
        </p>
        <div className="flex flex-wrap items-center gap-2">
          <button
            type="button"
            onClick={() => setLinksOpen(true)}
            data-testid="admin-store-links"
            title="Set real store listings and launch time"
            className={ghostBtn}
          >
            <Store className="h-3.5 w-3.5" /> Store links
          </button>
          <button
            type="button"
            onClick={onDigest}
            data-testid="admin-digest-send"
            title="Email me the weekly summary now"
            className={ghostBtn}
          >
            <Inbox className="h-3.5 w-3.5" /> Email digest
          </button>
          <button type="button" onClick={onRefresh} data-testid="admin-refresh" className={ghostBtn}>
            <RefreshCw className="h-3.5 w-3.5" /> Refresh
          </button>
          <button
            type="button"
            onClick={onLogout}
            data-testid="admin-logout"
            className="inline-flex h-10 items-center gap-2 rounded-full bg-forest px-4 text-xs font-bold text-bone transition-colors hover:bg-fresh"
          >
            <LogOut className="h-3.5 w-3.5" /> Sign out
          </button>
        </div>
      </div>
      <StoreLinksDialog open={linksOpen} onOpenChange={setLinksOpen} />
    </header>
  );
};
